import { EffectComposer } from "three/addons/postprocessing/EffectComposer.js";
import { RenderPass } from "three/addons/postprocessing/RenderPass.js";
import { UnrealBloomPass } from "three/addons/postprocessing/UnrealBloomPass.js";
import { ShaderPass } from "three/addons/postprocessing/ShaderPass.js";
import { Vector2, type WebGLRenderer, type Scene, type Camera, IUniform } from "three";
import grainFrag from "../shaders/grain.frag?raw";
import type { Settings } from "./tier";

interface ShaderDescriptor {
  uniforms: Record<string, IUniform>;
  vertexShader: string;
  fragmentShader: string;
}

export function createComposer(
  renderer: WebGLRenderer,
  scene: Scene,
  camera: Camera,
  s: Settings,
): EffectComposer | null {
  if (!s.postprocess) return null;
  const composer = new EffectComposer(renderer);
  composer.addPass(new RenderPass(scene, camera));
  const bloom = new UnrealBloomPass(
    new Vector2(window.innerWidth, window.innerHeight),
    0.7, 0.4, 0.85,
  );
  composer.addPass(bloom);
  if (s.postprocessFull) {
    const grainShader: ShaderDescriptor = {
      uniforms: { tDiffuse: { value: null }, uTime: { value: 0 } },
      vertexShader:
        "varying vec2 vUv; void main(){ vUv=uv; gl_Position=projectionMatrix*modelViewMatrix*vec4(position,1.0); }",
      fragmentShader: grainFrag,
    };
    composer.addPass(new ShaderPass(grainShader));
  }
  window.addEventListener("resize", () => {
    composer.setSize(window.innerWidth, window.innerHeight);
  });
  return composer;
}
